import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import matchSorter from 'match-sorter';
import { FormGroup } from 'reactstrap';
import { useIntl } from 'react-intl';

import AccessModalAddNew from './ModalAddNew';
import AccessModalSelectItem from './ModalSelectItem';
import SelectVirtualMenuList from '../SelectVirtualMenuList';

import {
  userIsAdmin,
  userIsManager,
} from '../../helpers/Auth';

const AccessModalAccessSelect = ({
  groups,
  users,
  selectedGroups,
  selectedUsers,
  singleSelect,
  showAddNewButton,
  showTeams,
  loading,
  saving,
  handleAddItem,
  handleAddNewGroup,
  handleAddNewUser,
}) => {
  const intl = useIntl();

  const [inputValue, setInputValue] = useState('');

  const items = showTeams ? groups.concat(users) : users;
  const selected = showTeams ? {
    ...selectedGroups,
    ...selectedUsers,
  } : selectedUsers;

  const getOptions = () => {
    const options = [];
    if (singleSelect && Object.keys(selected).length > 0) {
      items
        .filter(i => (selected[i.uuid]))
        .filter(i => (!i.deactivated_at))
        .forEach((i) => {
          if (i.email) {
            options.push({
              uuid: i.uuid,
              name: i.name,
              email: i.email,
              avatar: i.avatar_url,
              type: 'user',
            });
          } else {
            options.push({
              uuid: i.uuid,
              name: i.name,
              type: 'group',
            });
          }
        });
    }

    items
      .filter(i => (!selected[i.uuid]))
      .filter(i => (!i.deactivated_at))
      .forEach((i) => {
        if (i.email) {
          options.push({
            uuid: i.uuid,
            name: i.name,
            email: i.email,
            avatar: i.avatar_url,
            type: 'user',
          });
        } else {
          options.push({
            uuid: i.uuid,
            name: i.name,
            type: 'group',
          });
        }
      });

    return options;
  };

  const getSelected = () => {
    const selectedUuids = Object.keys(selected);
    return getOptions().find(i => (selectedUuids.includes(i.uuid))) || null;
  };

  const handleChange = (value) => {
    if (!value || !value.uuid) {
      handleAddItem(null);
    } else {
      handleAddItem(value.uuid, value.type);
    }
  };

  return (
    <FormGroup>
      <Select
        id="inpAccessAdd"
        inputId="inpAccessAdd"
        name="accessAdd"
        className="access-select user-select"
        classNamePrefix="user-select"
        placeholder={intl.formatMessage({ defaultMessage: 'Add users or Teams' })}
        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
        menuPortalTarget={document.body}
        noOptionsMessage={() => (intl.formatMessage({ defaultMessage: 'No users or Teams' }))}
        getOptionValue={option => option.uuid}
        getOptionLabel={option => option.name}
        components={{
          Option: AccessModalSelectItem,
          MenuList: SelectVirtualMenuList,
        }}
        isDisabled={loading || saving}
        isLoading={loading}
        isClearable={singleSelect}
        onChange={handleChange}
        options={matchSorter(getOptions(), inputValue, { keys: ['name', 'email'] })}
        filterOption={false}
        onInputChange={(v) => { setInputValue(v); }}
        value={singleSelect ? getSelected() : null}
      />
      {(showAddNewButton && (userIsAdmin() || userIsManager())) && (
        <AccessModalAddNew
          disabled={saving}
          handleAddNewGroup={handleAddNewGroup}
          handleAddNewUser={handleAddNewUser}
        />
      )}
    </FormGroup>
  );
};

AccessModalAccessSelect.propTypes = {
  groups: PropTypes.array.isRequired,
  users: PropTypes.array.isRequired,
  selectedGroups: PropTypes.object,
  selectedUsers: PropTypes.object,
  loading: PropTypes.bool.isRequired,
  saving: PropTypes.bool.isRequired,
  singleSelect: PropTypes.bool,
  showAddNewButton: PropTypes.bool,
  showTeams: PropTypes.bool,
  handleAddItem: PropTypes.func.isRequired,
  handleAddNewGroup: PropTypes.func,
  handleAddNewUser: PropTypes.func,
};

AccessModalAccessSelect.defaultProps = {
  selectedGroups: {},
  selectedUsers: {},
  singleSelect: false,
  showAddNewButton: false,
  showTeams: true,
  handleAddNewGroup: () => {},
  handleAddNewUser: () => {},
};

export default AccessModalAccessSelect;
